
export default function getTimestamp() {
    return Math.floor(Date.now() / 1000)
}